import React from 'react';
import styles from '../index.module.css';
import Kpi from './Kpi';

interface Props {
    title: string;
    value: string | number;
    active?: boolean;
    activeClass: string;
    inactiveClass: string;
    onClick?: () => void;
}

const KpiButton: React.FC<Props> = ({ title, value, active, activeClass, inactiveClass, onClick }) => {
    return (
        <button
            className={`${styles['button-holder']} ${active ? styles[activeClass] : styles[inactiveClass]}`}
            onClick={onClick}
        >
            <Kpi title={title} value={value} />
        </button>
    );
};

export default KpiButton;
